import {
	normalizeStatusLabel,
	statusMatchesFilter,
} from "../../../../../../../../../shared/utils/normalize-status-label";

interface SortInfo {
	sortMethod: string;
	sortBy: string;
}

const STATUS_PRIORITY: Record<string, number> = {
	PENDING: 0,
	MODERATION: 1,
	UPDATE: 2,
	ENABLED: 3,
	REMOVED: 4,
	BANNED: 5,
	EXTERNAL: 6,
};

const getStatusPriorityRank = (
	raw: string | number | null | undefined,
): number | undefined => {
	const label = normalizeStatusLabel(raw);
	const mapKey = label.replace(/\s+/g, "_");
	return STATUS_PRIORITY[mapKey];
};

export const processApps = (
	data: any[] | undefined,
	selectedStatus: string,
	sortInfo: SortInfo,
) => {
	const processed = (data || []).filter((item) =>
		statusMatchesFilter(item.status, selectedStatus),
	);

	const sorted = processed.slice().sort((a, b) => {
		const { sortBy, sortMethod } = sortInfo;
		let va: any = "";
		let vb: any = "";

		switch (sortBy) {
			case "app":
				va = a.app_id ?? "";
				vb = b.app_id ?? "";
				break;
			case "status": {
				const ra = getStatusPriorityRank(a.status);
				const rb = getStatusPriorityRank(b.status);
				const aUnknown = ra === undefined;
				const bUnknown = rb === undefined;
				if (aUnknown && bUnknown) {
					const sa = normalizeStatusLabel(a.status);
					const sb = normalizeStatusLabel(b.status);
					const cmp = String(sa).localeCompare(String(sb), undefined, {
						sensitivity: "base",
						numeric: true,
					});
					return sortMethod === "asc" ? cmp : -cmp;
				}
				if (aUnknown) return 1;
				if (bUnknown) return -1;
				const diff = ra - rb;
				return sortMethod === "asc" ? diff : -diff;
			}
			case "cost":
				va = parseFloat(String(a.cost_usd)) || 0;
				vb = parseFloat(String(b.cost_usd)) || 0;
				break;
			default:
				va = a.app_id ?? "";
				vb = b.app_id ?? "";
		}

		if (typeof va === "number" && typeof vb === "number") {
			return sortMethod === "asc" ? va - vb : vb - va;
		}

		const cmp = String(va).localeCompare(String(vb), undefined, {
			sensitivity: "base",
			numeric: true,
		});
		return sortMethod === "asc" ? cmp : -cmp;
	});

	return sorted;
};
